"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import dynamic from "next/dynamic";
import VendorsHero from "@/features/merchant-storefront/Hero";
import OurStory from "@/features/merchant-storefront/OurStory";
import CakeCoustamization from "@/features/merchant-storefront/CakeCoustamization";
import { StorefrontMenu } from "@/services/api/product/menu";
const VendorOffers = dynamic(() => import("@/components/vendor/VendorOffers"), {
  ssr: false,
  loading: () => null
});
const OurVeryBest = dynamic(() => import("@/features/merchant-storefront/OurVeryBest"), {
  ssr: false,
  loading: () => null
});
const MobileFooter = dynamic(() => import("@/components/MobileFooter"), {
  ssr: false,
  loading: () => null
});
interface VendorPageLayoutProps {
  vendorData: Record<string, unknown>;
  id: string;
  vendorSlug?: string;
  initialProducts?: Record<string, unknown>[];
  storyData?: Record<string, unknown> | null;
  initialMenus?: StorefrontMenu[];
}
const VendorPageLayout = memo(t0 => {
  const $ = _c(24);
  const {
    vendorData,
    id,
    vendorSlug,
    initialProducts,
    storyData,
    initialMenus
  } = t0;
  const vendor_offline = !vendorData?.is_active;
  const isStoryEnabled = Boolean((vendorData?.metadata as {
    story_enabled?: boolean;
  } | undefined)?.story_enabled);
  let t1;
  if ($[0] !== vendorData) {
    t1 = <VendorsHero vendorData={vendorData} />;
    $[0] = vendorData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Number(id);
  const t3 = vendorData?.free_shipping_threshold as number | undefined;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <VendorOffers vendorId={t2} freeShippingThreshold={t3} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = id as string;
  let t6;
  if ($[5] !== t5) {
    t6 = <OurVeryBest vendorId={t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== id || $[8] !== isStoryEnabled || $[9] !== storyData) {
    t7 = isStoryEnabled && <OurStory vendorId={id as string} initialStory={storyData} />;
    $[7] = id;
    $[8] = isStoryEnabled;
    $[9] = storyData;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = id as string;
  let t9;
  if ($[11] !== initialMenus || $[12] !== initialProducts || $[13] !== t8 || $[14] !== vendorSlug || $[15] !== vendor_offline) {
    t9 = <CakeCoustamization vendorId={t8} vendorSlug={vendorSlug} vendor_offline={vendor_offline} initialProducts={initialProducts} initialMenus={initialMenus} />;
    $[11] = initialMenus;
    $[12] = initialProducts;
    $[13] = t8;
    $[14] = vendorSlug;
    $[15] = vendor_offline;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MobileFooter />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t11 = <>{t1}{t4}{t6}{t7}{t9}{t10}</>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
});
VendorPageLayout.displayName = "VendorPageLayout";
export default VendorPageLayout;